module.exports = __webpack_public_path__ + "img/32.e3a33b8f.png";